"use strict";

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

!function (e, t) {
  for (var r in t) {
    e[r] = t[r];
  }
}(exports, function (e) {
  var t = {};function r(n) {
    if (t[n]) return t[n].exports;var o = t[n] = { i: n, l: !1, exports: {} };return e[n].call(o.exports, o, o.exports, r), o.l = !0, o.exports;
  }return r.m = e, r.c = t, r.d = function (e, t, n) {
    r.o(e, t) || Object.defineProperty(e, t, { enumerable: !0, get: n });
  }, r.r = function (e) {
    "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, { value: "Module" }), Object.defineProperty(e, "__esModule", { value: !0 });
  }, r.t = function (e, t) {
    if (1 & t && (e = r(e)), 8 & t) return e;if (4 & t && "object" == (typeof e === "undefined" ? "undefined" : _typeof(e)) && e && e.__esModule) return e;var n = Object.create(null);if (r.r(n), Object.defineProperty(n, "default", { enumerable: !0, value: e }), 2 & t && "string" != typeof e) for (var o in e) {
      r.d(n, o, function (t) {
        return e[t];
      }.bind(null, o));
    }return n;
  }, r.n = function (e) {
    var t = e && e.__esModule ? function () {
      return e.default;
    } : function () {
      return e;
    };return r.d(t, "a", t), t;
  }, r.o = function (e, t) {
    return Object.prototype.hasOwnProperty.call(e, t);
  }, r.p = "", r(r.s = 247);
}({ 247: function _(e, t, r) {
    e.exports = r(248);
  }, 248: function _(e, t, r) {
    "use strict";
    r.r(t), r.d(t, "Upload", function () {
      return n;
    });
    var n = function () {
      function n(e) {
        _classCallCheck(this, n);

        this.element = e, this.addEventHandlers();
      }

      _createClass(n, [{
        key: "addEventHandlers",
        value: function addEventHandlers() {
          var _this = this;

          this.element.addEventListener("dragover", function (e) {
            e.preventDefault(), _this.setReadyForDrop();
          }, !1), this.element.addEventListener("dragleave", function () {
            _this.idle();
          }, !1), this.element.addEventListener("drop", function () {
            _this.idle();
          }, !1);
        }
      }, {
        key: "setReadyForDrop",
        value: function setReadyForDrop() {
          this.element.classList.add(this.classes.dragOver);
        }
      }, {
        key: "idle",
        value: function idle() {
          this.element.classList.remove(this.classes.dragOver);
        }
      }, {
        key: "classes",
        get: function get() {
          return { dragOver: "upload--drag-over" };
        }
      }], [{
        key: "getSelector",
        value: function getSelector() {
          return "[data-rs-upload]";
        }
      }]);

      return n;
    }();
  } }));